var _rect, _path, _rect2, _rect3, _g, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _g2, _rect10, _rect11, _rect12, _rect13, _rect14, _path2, _circle, _path3, _circle2, _rect15, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 737,
    height: 554,
    viewBox: "0 0 737 554",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 102.288,
    y: 450.738,
    width: 444.605,
    height: 628.579,
    rx: 30.6624,
    transform: "rotate(-90 102.288 450.738)",
    fill: "#FCFAF9",
    stroke: "#29315D",
    strokeWidth: 12.265
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M411.977 444.605L411.977 12.2655",
    stroke: "#828B9D",
    strokeWidth: 3.06624
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 500.9,
    y: 424.758,
    width: 112.04,
    height: 147.635,
    rx: 12.011,
    transform: "rotate(-90 500.9 424.758)",
    fill: "#D9D9D9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 476.372,
    y: 288.226,
    width: 35.4795,
    height: 15.6348,
    rx: 7.81737,
    transform: "rotate(-90 476.372 288.226)",
    fill: "#D9D9D9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 686.761,
    y: 419.763,
    width: 8.70315,
    height: 8.70315,
    rx: 4.35158,
    transform: "rotate(-90 686.761 419.763)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 686.785,
    y: 405.258,
    width: 8.70315,
    height: 8.70315,
    rx: 4.35158,
    transform: "rotate(-90 686.785 405.258)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 686.786,
    y: 390.754,
    width: 8.70315,
    height: 8.70315,
    rx: 4.35158,
    transform: "rotate(-90 686.786 390.754)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 686.764,
    y: 376.25,
    width: 8.70315,
    height: 8.70315,
    rx: 4.35158,
    transform: "rotate(-90 686.764 376.25)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 686.773,
    y: 361.745,
    width: 8.70315,
    height: 8.70315,
    rx: 4.35158,
    transform: "rotate(-90 686.773 361.745)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 686.771,
    y: 347.227,
    width: 8.70315,
    height: 8.70315,
    rx: 4.35158,
    transform: "rotate(-90 686.771 347.227)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 686.773,
    y: 332.736,
    width: 8.70315,
    height: 8.70315,
    rx: 4.35158,
    transform: "rotate(-90 686.773 332.736)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 686.782,
    y: 318.23,
    width: 8.70315,
    height: 8.70315,
    rx: 4.35158,
    transform: "rotate(-90 686.782 318.23)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 686.761,
    y: 303.714,
    width: 8.70315,
    height: 8.70315,
    rx: 4.35158,
    transform: "rotate(-90 686.761 303.714)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 686.769,
    y: 289.208,
    width: 8.70315,
    height: 8.70315,
    rx: 4.35158,
    transform: "rotate(-90 686.769 289.208)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 686.778,
    y: 274.715,
    width: 8.70315,
    height: 8.70315,
    rx: 4.35158,
    transform: "rotate(-90 686.778 274.715)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 686.768,
    y: 260.211,
    width: 8.70315,
    height: 8.70315,
    rx: 4.35158,
    transform: "rotate(-90 686.768 260.211)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 686.782,
    y: 245.705,
    width: 8.70315,
    height: 8.70315,
    rx: 4.35158,
    transform: "rotate(-90 686.782 245.705)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 686.768,
    y: 231.189,
    width: 8.70315,
    height: 8.70315,
    rx: 4.35158,
    transform: "rotate(-90 686.768 231.189)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 686.778,
    y: 216.685,
    width: 8.70315,
    height: 8.70315,
    rx: 4.35158,
    transform: "rotate(-90 686.778 216.685)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 686.78,
    y: 202.18,
    width: 8.70315,
    height: 8.70315,
    rx: 4.35158,
    transform: "rotate(-90 686.78 202.18)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 686.78,
    y: 187.686,
    width: 8.70315,
    height: 8.70315,
    rx: 4.35158,
    transform: "rotate(-90 686.78 187.686)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 686.768,
    y: 173.17,
    width: 8.70315,
    height: 8.70315,
    rx: 4.35158,
    transform: "rotate(-90 686.768 173.17)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 686.768,
    y: 158.678,
    width: 8.70315,
    height: 8.70315,
    rx: 4.35158,
    transform: "rotate(-90 686.768 158.678)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 686.77,
    y: 144.161,
    width: 8.70315,
    height: 8.70315,
    rx: 4.35158,
    transform: "rotate(-90 686.77 144.161)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 686.786,
    y: 129.669,
    width: 8.70315,
    height: 8.70315,
    rx: 4.35158,
    transform: "rotate(-90 686.786 129.669)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 686.767,
    y: 115.151,
    width: 8.70315,
    height: 8.70315,
    rx: 4.35158,
    transform: "rotate(-90 686.767 115.151)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 686.773,
    y: 100.658,
    width: 8.70315,
    height: 8.70315,
    rx: 4.35158,
    transform: "rotate(-90 686.773 100.658)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 686.771,
    y: 86.1419,
    width: 8.70315,
    height: 8.70315,
    rx: 4.35158,
    transform: "rotate(-90 686.771 86.1419)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 686.773,
    y: 71.6371,
    width: 8.70315,
    height: 8.70315,
    rx: 4.35158,
    transform: "rotate(-90 686.773 71.6371)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 686.774,
    y: 57.1329,
    width: 8.70315,
    height: 8.70315,
    rx: 4.35158,
    transform: "rotate(-90 686.774 57.1329)",
    fill: "#D9D9D9"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 533.98,
    y: 288.227,
    width: 128.205,
    height: 15.6348,
    rx: 7.81737,
    transform: "rotate(-90 533.98 288.227)",
    fill: "#D9D9D9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 562.541,
    y: 288.227,
    width: 172.963,
    height: 15.6348,
    rx: 7.81737,
    transform: "rotate(-90 562.541 288.227)",
    fill: "#D9D9D9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 606.583,
    y: 288.228,
    width: 35.4795,
    height: 15.6348,
    rx: 7.81737,
    transform: "rotate(-90 606.583 288.228)",
    fill: "#D9D9D9"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 606.594,
    y: 177.626,
    width: 35.4795,
    height: 15.6348,
    rx: 7.81737,
    transform: "rotate(-90 606.594 177.626)",
    fill: "#D9D9D9"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 632.672,
    y: 288.227,
    width: 72.4374,
    height: 15.6348,
    rx: 7.81737,
    transform: "rotate(-90 632.672 288.227)",
    fill: "#D9D9D9"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 632.646,
    y: 177.64,
    width: 72.4374,
    height: 15.6348,
    rx: 7.81737,
    transform: "rotate(-90 632.646 177.64)",
    fill: "#D9D9D9"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 476.368,
    y: 214.636,
    width: 29.5663,
    height: 15.6348,
    rx: 7.81737,
    transform: "rotate(-90 476.368 214.636)",
    fill: "#D9D9D9"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 476.372,
    y: 147.18,
    width: 69.0144,
    height: 15.8787,
    rx: 7.93934,
    transform: "rotate(-90 476.372 147.18)",
    fill: "#D9D9D9"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 507.03,
    y: 55.1924,
    width: 21.4637,
    height: 12.265,
    rx: 6.13248,
    transform: "rotate(-90 507.03 55.1924)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 522.661,
    y: 55.1809,
    width: 21.4637,
    height: 12.265,
    rx: 6.13248,
    transform: "rotate(-90 522.661 55.1809)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 538.31,
    y: 55.1809,
    width: 21.4637,
    height: 12.265,
    rx: 6.13248,
    transform: "rotate(-90 538.31 55.1809)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 553.935,
    y: 55.1809,
    width: 21.4637,
    height: 12.265,
    rx: 6.13248,
    transform: "rotate(-90 553.935 55.1809)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 569.583,
    y: 55.1809,
    width: 21.4637,
    height: 12.265,
    rx: 6.13248,
    transform: "rotate(-90 569.583 55.1809)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 585.205,
    y: 55.1927,
    width: 21.4637,
    height: 12.265,
    rx: 6.13248,
    transform: "rotate(-90 585.205 55.1927)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 600.833,
    y: 55.1927,
    width: 21.4637,
    height: 12.265,
    rx: 6.13248,
    transform: "rotate(-90 600.833 55.1927)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 616.463,
    y: 55.1809,
    width: 21.4637,
    height: 12.265,
    rx: 6.13248,
    transform: "rotate(-90 616.463 55.1809)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 632.088,
    y: 55.1927,
    width: 21.4637,
    height: 12.265,
    rx: 6.13248,
    transform: "rotate(-90 632.088 55.1927)",
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 270.018,
    y: 55.1839,
    width: 96.4347,
    height: 92.6896,
    rx: 9.82994,
    transform: "rotate(-0.466942 270.018 55.1839)",
    stroke: "#D9D9D9",
    strokeWidth: 8.42453,
    strokeLinejoin: "round"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: -2.95877,
    y: -2.91151,
    width: 66.8413,
    height: 21.4705,
    transform: "matrix(0.999999 -0.00124249 0.014859 0.99989 287.81 75.1077)",
    fill: "#D9D9D9",
    stroke: "#E2E3E9",
    strokeWidth: 5.83091,
    strokeLinejoin: "round"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: -2.95877,
    y: -2.91151,
    width: 66.8413,
    height: 21.4143,
    transform: "matrix(0.999999 -0.00124249 0.014859 0.99989 286.556 111.001)",
    fill: "#D9D9D9",
    stroke: "#E2E3E9",
    strokeWidth: 5.83091,
    strokeLinejoin: "round"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 203.442,
    y: 286.174,
    width: 49.277,
    height: 111.373,
    rx: 7.3445,
    transform: "rotate(36.2155 203.442 286.174)",
    stroke: "#D9D9D9",
    strokeWidth: 9.19872
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 207.188,
    y: 310.437,
    width: 14.5643,
    height: 76.649,
    rx: 1.2265,
    transform: "rotate(36.2155 207.188 310.437)",
    fill: "#D9D9D9",
    stroke: "#E2E3E9",
    strokeWidth: 9.19872
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M216.996 110.601C219.299 108.708 219.311 105.188 217.022 103.279L166.4 61.0699C163.31 58.4939 158.617 60.6812 158.603 64.7036L158.309 148.767C158.295 152.789 162.973 155.009 166.08 152.455L216.996 110.601Z",
    fill: "#D9D9D9",
    stroke: "#E2E3E9",
    strokeWidth: 7.66786
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 316.31,
    cy: 354.904,
    r: 44.0026,
    fill: "#D9D9D9"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M602.419 445.158C604.287 437.959 605.282 430.408 605.282 422.624C605.282 373.229 565.239 333.186 515.844 333.186C466.449 333.186 426.406 373.229 426.406 422.624C426.406 430.408 427.4 437.959 429.268 445.158L496.435 445.158C490.108 439.703 486.103 431.63 486.103 422.621C486.103 406.195 499.419 392.88 515.845 392.88C532.271 392.88 545.587 406.195 545.587 422.621C545.587 431.63 541.581 439.703 535.254 445.158L602.419 445.158Z",
    fill: "#09093E"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 516.998,
    cy: 422.374,
    r: 31.429,
    transform: "rotate(-90 516.998 422.374)",
    fill: "#E3E3E9"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 482.502,
    y: 456.87,
    width: 12.265,
    height: 61.3248,
    transform: "rotate(-90 482.502 456.87)",
    fill: "#29315D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6489 89.0127C17.2816 86.8672 18.7232 84.8302 20.8687 84.4629L311.794 34.6614C331.824 31.2326 350.841 44.6905 354.27 64.7204L419.961 448.467C423.39 468.497 409.932 487.514 389.902 490.943L98.9763 540.745C96.8308 541.112 94.7938 539.67 94.4266 537.525L17.6489 89.0127Z",
    fill: "#29315D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M108.084 249.446L318.521 213.423",
    stroke: "#3158F2",
    strokeWidth: 11.6517,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M231.297 336.63C173.048 346.601 118.038 307.672 108.067 249.423C98.0956 191.174 137.025 136.164 195.274 126.193",
    stroke: "#3158F2",
    strokeWidth: 11.6517,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M195.279 126.207C253.528 116.235 308.538 155.165 318.509 213.413C328.48 271.662 289.551 326.672 231.302 336.643",
    stroke: "#3158F2",
    strokeWidth: 11.6517,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M195.254 126.2C150.659 193.79 166.74 287.729 231.277 336.637C275.872 269.047 259.792 175.108 195.254 126.2Z",
    stroke: "#3158F2",
    strokeWidth: 11.6517,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M274.332 392.503L222.557 401.187C217.865 401.974 214.689 406.43 215.476 411.122L221.147 444.935C221.934 449.627 226.39 452.803 231.082 452.016L282.857 443.331C287.549 442.544 290.725 438.088 289.938 433.397L284.267 399.584C283.48 394.892 279.024 391.716 274.332 392.503ZM283.489 434.478C283.679 435.613 282.91 436.692 281.776 436.882L230 445.566C228.866 445.757 227.787 444.988 227.596 443.853L225.282 430.055L240.212 427.551C242.612 433.143 248.605 436.6 254.868 435.549C261.131 434.499 265.669 429.275 266.113 423.207L281.175 420.681L283.489 434.478ZM245.753 423.374C245.117 419.582 247.686 415.977 251.479 415.341C255.271 414.705 258.876 417.274 259.512 421.067C260.148 424.859 257.579 428.464 253.786 429.1C249.994 429.736 246.389 427.167 245.753 423.374ZM280.093 414.231L264.998 416.763C262.563 411.246 256.613 407.849 250.397 408.892C244.181 409.934 239.665 415.087 239.163 421.097L224.2 423.606L221.925 410.04C221.735 408.906 222.504 407.827 223.638 407.637L275.414 398.952C276.548 398.762 277.627 399.531 277.818 400.666L280.093 414.231Z",
    fill: "#3158F2",
    stroke: "#3158F2",
    strokeWidth: 1.18239
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignUp);
export default __webpack_public_path__ + "static/media/sign-up.e9e698b6fa62a64c0f58ac83403ab163.svg";
export { ForwardRef as ReactComponent };